import { render, staticRenderFns } from "./Motor.vue?vue&type=template&id=72ca9935"
import script from "./Motor.vue?vue&type=script&lang=js"
export * from "./Motor.vue?vue&type=script&lang=js"
import style0 from "./Motor.vue?vue&type=style&index=0&id=72ca9935&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports